import { render, staticRenderFns } from "./ClassStatistics.vue?vue&type=template&id=469616ce&scoped=true&"
import script from "./ClassStatistics.vue?vue&type=script&lang=js&"
export * from "./ClassStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ClassStatistics.vue?vue&type=style&index=0&id=469616ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469616ce",
  null
  
)

export default component.exports